import gql from 'graphql-tag';

export const VALIDATE_CONTAINER = gql`
  query validateContainerMetadata(
    $scannableContainerId: String,
    $locationIdList: [String],
    $containerType: ContainerType
  ) {
    validateContainerMetadata(
      scannableContainerId: $scannableContainerId,
      locationIdList: $locationIdList,
      containerType: $containerType
    ) {
      cmsSiteLaunched
      containerValidationList {
        containerId
        scannableContainerId
        containerType
        status {
          validationStatusType
          statusCode
          statusMessage
        }
      }
    }
  }
`;

export const CONTAINER_SUGGESTIONS = gql`
  query getContainerSuggestions(
    $mpn: String,
    $site: String
    ) {
      getContainerSuggestions(
        mpn: $mpn,
        site: $site
      ) {
        containers {
          containerName
          quantity
        }
      }
    }
  `;
